import React from "react";
import ServiceCard from "./ServiceCard";
import serviceImage1 from "../assets/service1.webp";
import serviceImage2 from "../assets/service2.webp";
import serviceImage3 from "../assets/service3.webp";
import serviceImage4 from "../assets/service4.webp";
import serviceImage5 from "../assets/service5.jpg";
import serviceImage6 from "../assets/service6.jpeg";

const ServicesSection = () => {
  const services = [
    {
      image: serviceImage1,
      title: "MES Projeleri",
      description:
        "Üretim süreçlerinizi dijitalleştirerek izlenebilirliği ve verimliliği artırıyoruz. Entegre çözümlerle üretiminize değer katıyoruz.",
    },
    {
      image: serviceImage2,
      title: "OEE Çözümleri",
      description:
        "Ekipman etkinliği analizleri ile üretim kayıplarınızı minimuma indiriyor, süreçlerinizi optimize ediyoruz.",
    },
    {
      image: serviceImage3,
      title: "Danışmanlık Hizmetleri",
      description:
        "Dijital dönüşüm projelerinizi planlamak ve hayata geçirmek için uzman kadromuzla yanınızdayız.",
    },
    {
      image: serviceImage4,
      title: "ERP Çözümleri",
      description:
        "Kaynak yönetimi ve iş süreçlerinizi daha verimli hale getirmek için özelleştirilmiş ERP çözümleri sunuyoruz.",
    },
    {
      image: serviceImage5,
      title: "MRP Sistemleri",
      description:
        "Malzeme ihtiyaç planlamasıyla üretim sürecinizin her aşamasını optimize ediyoruz.",
    },
    {
      image: serviceImage6,
      title: "Elektronik Kart Tasarımı",
      description:
        "Endüstriyel uygulamalar için yenilikçi elektronik kart tasarımlarıyla projelerinizi ileri taşıyoruz.",
    },
  ];
  

  return (
    <section className="bg-gray-100 py-12">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">
          Hizmetlerimiz
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              image={service.image}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
